import React, { Component } from "react";
import { DetectEnvironment } from "../../../EnvironmentSettings";

import { ProgressSpinner } from "primereact/progressspinner";
import { NavLink } from "react-router-dom";
import Spinner from "./../../../components/spinner/spinner";
import { loginService } from "../../../services/loginService";
import { LoginResponse, RoleInterface, LoginFormType, Templates } from "../../../models/index";
import "./login.css";
import { Password } from "primereact/password";
import { reportsScreenSubRoutes } from "./../../WgReportSubMenu/ReportsSidebar";
// import Cookies from "universal-cookie";

import { Input, Form, Label } from "reactstrap";
import { Toast } from "primereact/toast";
import { SettingsCookieModal } from "../../../components/NavigationBar/Models/SettingCookieModel";
import { cookieService } from "../../../services/CookieService";
import { LoginCookies } from "./Models";
import { utils } from "../../../utils";
import axios from "axios";
import { RadioButton } from 'primereact/radiobutton';
import { wglcsApiService } from "../../../services/WglcsApiService";
import { Ripple } from "primereact/ripple";
import moment from "moment";
import { LocalStorageService } from "../../../services/localStorageService";
import MainLogo from "../SignUpScreens/MainLogo";
import { botApiService } from "../../../services/BotApiService";
const { detect } = require("detect-browser");
const browser = detect();
// const cookies = new Cookies();

interface LoginState {
    isChecked: boolean;
    erroremail: boolean;
    errorpassword: boolean;
    errorlicenseKey: boolean;
    email: string;
    password: string;
    licenseKey: string;
    settings: any;
    isLoading: boolean;
    customLoading: boolean;
    ipAddress: string;
    currentBrowser: string;
    selectedFormType: LoginFormType;
    code: string;
    errorCode: boolean;
    verificationType: string;
    methodType: string;
    generatedCode: string;
    refreshState: any;
    persistedLanguage: any;
    isIOSDevice: boolean
}

interface LoginProps {
    onSuccess: (LoginResponse: LoginResponse) => void;
}

class Login extends Component<LoginProps, LoginState> {
    toast: Toast | null = null;
    loginData: any = null;
    selectedEnvironment = null

    constructor(props) {
        super(props);
        var userCookies = cookieService.getLoginCookies();
        this.state = {
            // isChecked: false,
            // email: "",
            // password: "",
            // licenseKey: "",
            isChecked: userCookies?.isChecked ? true : false,
            email: userCookies?.username ?? "",
            password: userCookies?.password ?? "",
            licenseKey: userCookies?.licenseKey ?? "",
            erroremail: false,
            errorpassword: false,
            errorlicenseKey: false,
            isLoading: false,
            customLoading: false,
            ipAddress: "",
            currentBrowser: "",
            refreshState: '',
            selectedFormType: LoginFormType.SignIn,
            code: "",
            settings: null,
            errorCode: false,
            verificationType: "",
            methodType: "",
            generatedCode: "",
            persistedLanguage: null,
            isIOSDevice: false
        };

        this.handleLoginClick = this.handleLoginClick.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
    }

    componentDidMount() {
        const deviceName = cookieService.getCookies("apple")
        // alert("is this Apple device :" + deviceName)
        if (deviceName != undefined && deviceName != null) {
            if (deviceName == "true") {
                this.setState({ isIOSDevice: true })
            }
        }

        // this.clearAllData()

        this.selectedEnvironment = DetectEnvironment.config;

        if (utils.isElectronBuild()) {
            this.setState({ licenseKey: "01-05-03-01" })
            window?.myAPI?.RequestForSettings("Request for settings")
            window?.myAPI?.RequestForLoginCrendentials("Request for data")
            window.myAPI?.requestToGetPersistedSettings("")
        }

        var path = utils.getCurrentPathName();
        var token = path.split("=")
        if (parseInt(token[1]) > 0) {
            localStorage.setItem("fireBaseToken", JSON.stringify(token[1]))
        }

        this.getIpAddress()

        if (browser) {
            let AppName = utils.isElectronBuild() ? "React Electron : " : "React Web : ";
            AppName += `version : ${process.env.REACT_APP_VERSION} :`
            this.setState({ currentBrowser: AppName + browser.name + " " + browser.version + " : " + browser.os });
        }
        document.addEventListener("keydown", this.processKeyEvent);
        if (utils.isElectronBuild()) {
            window?.myAPI?.ReturnLoginCrendentials("ReturnLoginCrendentials", (data) => {
                if (data != undefined && data != "") {

                    // let dt = JSON.parse(data)
                    let dt = data
                    this.setState({
                        email: dt.username,
                        password: dt.password,
                        isChecked: dt.isChecked
                    })
                }
            });
            window?.myAPI?.getPersistedSettings("getPersistedSettings", (data) => {
                let dt = JSON.parse(data)
                this.setState({
                    settings: dt,
                    refreshState: new Date().getTime() + this.state.settings + new Date().getTime()
                })
            });

            window?.myAPI?.ReturnLanguageSettings("ReturnLanguageSettings", (data) => {
                if (data != null) {
                    this.setState({ persistedLanguage: data })
                }
            });
        }
    }



    clearAllData = () => {
        // Clear localStorage
        localStorage.clear();

        // Clear sessionStorage
        sessionStorage.clear();

        // Clear IndexedDB
        if (window.indexedDB) {
            indexedDB.databases().then((databases) => {
                databases.forEach((db: any) => {
                    if (db) {
                        indexedDB.deleteDatabase(db?.name);
                    }
                });
            });
        }

        // Clear cache storage
        if ('caches' in window) {
            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
        }

    };

    getIpAddress = async () => {
        let ip = await wglcsApiService.getIpAddress();
        LocalStorageService.setLocalStorage("loginTimeApi", ip);
        this.setState({ ipAddress: ip as any });
        return ip as any
    };

    handleChecked(e) {
        if (utils.isElectronBuild()) {
            if (e.target.checked) {
                var userData = {
                    username: this.state.email,
                    password: this.state.password,
                    licenseKey: this.state.licenseKey,
                    isChecked: e.target.checked,
                }
                window?.myAPI?.SaveLoginCrendentialsInFile(userData)
            } else {
                let emptyValue = {
                    username: '',
                    password: '',
                    licenseKey: '',
                    isChecked: false,
                }
                window?.myAPI?.SaveLoginCrendentialsInFile(emptyValue)
            }
        }
        else {
            if (e.target.checked) {
                var t = {
                    username: this.state.email,
                    password: this.state.password,
                    licenseKey: this.state.licenseKey,
                    isChecked: e.target.checked
                }
                cookieService.setLoginCookies(t)
            } else {
                let empty = {
                    username: '',
                    password: '',
                    licenseKey: '',
                    isChecked: false,

                }
                cookieService.setLoginCookies(empty)
            }
        }
        this.setState((prevState) => ({
            isChecked: !prevState.isChecked,
        }));
    }
    processKeyEvent = (event) => {
        if (event.key?.toString() === "Enter") {
            this.handleLoginClick();
        }
    };

    persistSettigInCookies = (userId: number) => {

        var cookie = cookieService.getSettingsCookies();
        if (!utils.isElectronBuild()) {
            if (cookie == null || cookie?.userId !== userId) {
                var newCookie: SettingsCookieModal = {
                    chatNotifications: false,
                    soundAlerts: true,
                    unsentChatNotifications: true,
                    selectedTemplate: Templates.Template1,
                    linkPreview: true,
                    userId: userId
                };
                cookieService.setSettingsCookies(newCookie);
            }
        } else {
            var electronSetting: SettingsCookieModal = {
                chatNotifications: true,
                soundAlerts: this.state.settings?.soundAlerts,
                unsentChatNotifications: this.state.settings?.unsentChatNotifications,
                selectedTemplate: this.state.settings?.selectedTemplate,
                linkPreview: this.state.settings?.linkPreview,
                userId: userId
            };
            return cookieService.setSettingsCookies(electronSetting);
        }
    }

    handleTwoFactor = () => {
        if (this.state.code == this.state.generatedCode) {
            this.loginSuccess(this.loginData)
        }
        else {
            this.toast?.show({ severity: "error", summary: "Authentication", detail: "Your code is not valid!", contentClassName: "" });
            this.setState({ code: "" })
        }
    }

    sendVerficatoinCode = async () => {
        this.setState({ customLoading: true })
        let _code = utils.GenerateRandomCode()

        let obj = {
            userId: this.loginData?.data?.userLoginData.userId,
            verificationCode: _code?.toString(),
            verificationType: this.state.methodType
        }
        let response = await wglcsApiService.send_verificationcode(obj)

        if (response?.data?.data) {
            this.toast?.show({ severity: "success", summary: "Success", detail: "Code sent successfully!", contentClassName: "" });
            setTimeout(() => {
                this.setState({ selectedFormType: LoginFormType.CodeVerification, generatedCode: _code?.toString() })
            }, 2000);
        }
        else {
            this.toast?.show({ severity: "error", summary: "Authentication", detail: response?.data?.msg, contentClassName: "" });
        }

        this.setState({ customLoading: false })
    }


    loginSuccess = async (loginResult) => {
        const { email, password, licenseKey } = this.state;

        this.persistSettigInCookies(loginResult.data.userLoginData.userId);

        if (this.state.isChecked) {
            var obj = {
                username: email,
                password,
                licenseKey,
                isChecked: true
            } as LoginCookies;

            cookieService.setLoginCookies(obj);
        } else {
            cookieService.removeLoginCookies();
        }

        var loginData = loginResult.data;
        var res = this.customizeInterfaces(loginResult.data?.interfaces);
        if (res !== null) {
            loginData.interfaces = res;
        }

        cookieService.removeElectronCookies("logOut");
        localStorage.setItem("loggedinTime", new Date().toString());
        cookieService.setElectronCookies("is-sidebar-expanded", false);

        if (utils.isElectronBuild()) {
            await this.manageLanguageSetting(loginResult)
        } else {
            let language = utils.getLanguageById(loginResult);
            cookieService.setElectronCookies('language', language);
        }

        LocalStorageService.setLocalStorage("loginTimeApi", this.state.ipAddress);
        this.props.onSuccess(loginData);
    }

    manageLanguageSetting = (loginResult) => {
        return new Promise((resolve, reject) => {
            try {
                if (this.state.persistedLanguage != null) {
                    if (this.state.persistedLanguage?.userId?.toString() === loginResult.data.userLoginData.userId?.toString()) {
                        cookieService.setElectronCookies('language', this.state.persistedLanguage?.selectedLanguage);
                    } else {
                        let language = utils.getLanguageById(loginResult);
                        cookieService.setElectronCookies('language', language);
                        let obj = { userId: loginResult.data.userLoginData.userId, selectedLanguage: language }
                        window.myAPI.PersistLanguage(obj)
                    }
                } else {
                    let language = utils.getLanguageById(loginResult);
                    cookieService.setElectronCookies('language', language);
                    let obj = { userId: loginResult.data.userLoginData.userId, selectedLanguage: language }
                    window.myAPI.PersistLanguage(obj)
                }

                resolve("Language setting successfully managed.");
            } catch (error) {
                reject(error);
            }
        });
    };

    async handleLoginClick() {
        if (utils.isElectronBuild()) {
            if (this.state.isChecked) {
                var userData = {
                    username: this.state.email,
                    password: this.state.password,
                    licenseKey: this.state.licenseKey,
                    isChecked: true,
                }
                window?.myAPI?.SaveLoginCrendentialsInFile(userData)
            } else {
                let emptyValue = {
                    username: '',
                    password: '',
                    licenseKey: '',
                    isChecked: false,
                }
                window?.myAPI?.SaveLoginCrendentialsInFile(emptyValue)
            }
        }
        else {
            if (this.state.isChecked) {
                var t = {
                    username: this.state.email,
                    password: this.state.password,
                    licenseKey: this.state.licenseKey,
                    isChecked: true
                }
                cookieService.setLoginCookies(t)
            } else {
                let empty = {
                    username: '',
                    password: '',
                    licenseKey: '',
                    isChecked: false,

                }
                cookieService.setLoginCookies(empty)
            }
        }
        var { email, password, licenseKey } = this.state;
        if (this.state.isIOSDevice) {
            const body = {
                userName: email,
                password: password,
                licenseKey: licenseKey,
                ipAddress: this.state.ipAddress,
                computerName: this.state.currentBrowser,
            }
            var response = await wglcsApiService.wglogin(body);
            if (!response?.data?.status) {
                error = "Please check your credentials and try again!";
                this.setState({ customLoading: false });
                this.toast?.show({
                    severity: "error",
                    summary: "Authentication",
                    detail: error,
                    contentClassName: "",
                });
                return;
            }



            if (response?.data?.status && !response?.data?.msg?.includes('Success')) {
                this.setState({ licenseKey: response?.data?.msg })
                licenseKey = response?.data?.msg
            }
            else {
                this.setState({ isIOSDevice: false })
            }
        }


        if (email && password && licenseKey) {
            this.setState({ customLoading: true });
            const latestIP = await this.getIpAddress()
            const convertedName = utils.convertFirstCapital(email?.toLowerCase())

            var loginResult = await loginService.login(convertedName, password, licenseKey, latestIP, this.state.currentBrowser);

            if (loginResult.success) {
                this.loginData = loginResult
                var beforeTime = new Date()
                // const botResponse = await botApiService.userSignIn("saleet", "Haramuss212");
                // LocalStorageService.setLocalStorage("BOT_USER_DATA", botResponse?.data?.key);
                // console.log(botResponse);

                this.loginData = loginResult;
                var beforeTime = new Date();

                const date1 = moment(beforeTime);
                const date2 = moment(loginResult.data?.userLoginData?.currentTime);
                const diffMilliseconds = date2.diff(date1);

                // Convert milliseconds to seconds
                const diffSeconds = Math.floor(diffMilliseconds / 1000);
                LocalStorageService.setLocalStorage("timeDifference", diffSeconds)

                this.setState({ customLoading: false });
                if (loginResult?.data?.userLoginData?.twoFactorAuthentication == "2FA") {
                    this.setState({ selectedFormType: LoginFormType.MethodSelection })
                    return;
                }

                this.loginSuccess(loginResult)
            } else {

                var error = ""
                if (loginResult?.message?.toString()?.includes("You have incorrectly typed your password several times. Try again in 5")) {
                    error = "You have incorrectly typed your password several times. Try again in 5 mins"
                }
                else {
                    error = "Please check your credentials and try again!"
                }

                if (loginResult?.message?.toString()?.includes("Please Login dashboard and acknowledge your pending tickets.")) {
                    error = "Please Login dashboard and acknowledge your pending tickets."
                }

                if (loginResult?.message?.toString()?.includes("Network Error")) {
                    error = "Please check your Internet Connection and try again!"
                }

                this.setState({ customLoading: false });
                this.toast?.show({
                    severity: "error",
                    summary: "Authentication",
                    detail: error,
                    contentClassName: "",
                });
            }
        } else {
            if (!email) {
                this.setState({ erroremail: true });
            } else {
                this.setState({ erroremail: false });
            }
            if (!password) {
                this.setState({ errorpassword: true });
            } else {
                this.setState({ errorpassword: false });
            }
            if (!licenseKey) {
                this.setState({ errorlicenseKey: true });
            } else {
                this.setState({ errorlicenseKey: false });
            }
            this.toast?.show({ severity: "error", summary: "Authentication", detail: "Please enter your credentials!", contentClassName: "" });
        }
    }

    customizeInterfaces = (interfaces: RoleInterface[]) => {

        if (utils.isMonitoringPanelAllowed(interfaces)) {
            interfaces.push({ interfaceId: 0, interfaceName: "Monitoring Panel" })
        }

        if (utils.isHybridPanelAllowed(interfaces)) {
            interfaces.push({ interfaceId: 0, interfaceName: "Hybrid Panel" });
        }
        if (utils.isQuickResponses(interfaces)) {
            interfaces.push({ interfaceId: 0, interfaceName: "Quick Responses" });
        }



        let _interfaces = this.getReportModulePermission(interfaces)
        return _interfaces;
    };


    getReportModulePermission = (interfaces) => {
        var isAllowed = false
        const flattenedSubArrays = reportsScreenSubRoutes()?.flatMap(item => item.subArray);
        flattenedSubArrays?.forEach(element => {
            if (interfaces?.some(x => x.interfaceName?.toLowerCase() == element.interfaceName?.toLowerCase())) {
                isAllowed = true
            }
        });

        if (!isAllowed) {
            let filtered = interfaces?.filter(c => c.interfaceName != "Dashboard Reports")
            return filtered
        }

        return interfaces
    }


    componentWillUnmount() {
        document.removeEventListener("keydown", this.processKeyEvent);
    }


    renderLoginForm = () => {
        return (
            <>
                <div className="login-head">
                    <h1>
                        Sign in to <br />
                        {DetectEnvironment.config.REACT_APP_TITLE}
                    </h1>
                </div>
                <Form>
                    <div className="form-group">
                        <img
                            className="login-input-image"
                            title="Email"
                            src={process.env.PUBLIC_URL + "/css/resources-images/email.svg"}
                            alt=""
                        />
                        <Input
                            onChange={(value) => {
                                this.setState({ email: value.target.value.toString(), erroremail: false });
                            }}
                            value={this.state.email}
                            type="email"
                            className="login-input"
                            name="inputEmail"
                            id="inputEmail"
                            placeholder="Username"
                            style={this.state.erroremail ? { borderWidth: 1, borderColor: "red" } : {}}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <img
                            className="login-input-image"
                            title="Email"
                            src={process.env.PUBLIC_URL + "/css/resources-images/ath.svg"}
                            alt=""
                        />
                        <Password
                            panelClassName="panelClassName"
                            placeholder="Password"
                            toggleMask
                            value={this.state.password}
                            onChange={(e) => {
                                this.setState({ password: e.target.value, errorpassword: false });
                            }}
                            autoComplete=""
                        />
                    </div>

                    {!this.state.isIOSDevice && <div className="form-group">
                        <img
                            className="login-input-image"
                            title="Email"
                            src={process.env.PUBLIC_URL + "/css/resources-images/License-Key.svg"}
                            alt=""
                        />
                        <Input
                            onChange={(value) => {
                                this.setState({ licenseKey: value.target.value, errorlicenseKey: false });
                            }}
                            value={this.state.licenseKey}
                            type="text"
                            className="login-input"
                            style={this.state.errorlicenseKey ? { borderWidth: 1, borderColor: "red" } : {}}
                            name="licenseKey"
                            id="licenseKey"
                            placeholder="License key"
                            required
                        />
                    </div>}

                    <div className="form-group" style={{ marginTop: "0px" }}>
                        <div className="custom-control custom-checkbox mx-2 ">
                            <Input
                                type="checkbox"
                                className="custom-control-input"
                                checked={this.state.isChecked}
                                onChange={this.handleChecked}
                                id="rememberme"
                            />
                            <Label className="custom-control-label remember-label float-left " for="rememberme">
                                Remember me
                            </Label>
                        </div>
                    </div>
                    <div className="form-group" style={{ margin: "0px", textAlign: "center" }}>
                        {this.state.customLoading ? (
                            <ProgressSpinner />
                        ) : (
                            <button type="button" onClick={this.handleLoginClick} className="signin-btn p-ripple">
                                <Ripple />  Sign in
                            </button>
                        )}
                    </div>
                </Form>
            </>
        )
    }


    renderMethodSelectionForm = () => {
        return (
            <>
                <div className="login-head">
                    <h2>Two-factor Authentication</h2>
                    <h6>Please choose a method to verify your account</h6>
                    <Form>
                        <div className="form-group-">

                            <div className="p-field-radiobutton">
                                <RadioButton inputId="city4" name="city" value="Email" onChange={(e) => this.setState({ methodType: e.value })} checked={this.state.methodType === 'Email'} />
                                <label className="type-selection-radio-button" htmlFor="city4">Email</label>
                            </div>

                            <div className="p-field-radiobutton">
                                <RadioButton inputId="city3" name="city" value="Sms" onChange={(e) => this.setState({ methodType: e.value })} checked={this.state.methodType === 'Sms'} />
                                <label className="type-selection-radio-button" htmlFor="city3">SMS</label>
                            </div>

                            <div className="form-group" style={{ margin: "0px", textAlign: "center" }}>
                                {this.state.customLoading ? (
                                    <ProgressSpinner />
                                ) : (
                                    <button type="button" onClick={this.sendVerficatoinCode} className="signin-btn  p-ripple">
                                        <Ripple />    Send verification code
                                    </button>
                                )}
                            </div>
                        </div>
                    </Form>
                </div>
            </>
        )
    }

    renderTwofactorAuthenticationForm = () => {
        return (<>
            <div className="login-head">
                <h2>Authentication Code</h2>
                <Form>
                    <div className="form-group">
                        <img
                            className="login-input-image"
                            title="Code"
                            src={process.env.PUBLIC_URL + "/css/resources-images/email.svg"}
                            alt=""
                        />
                        <Input
                            onChange={(value) => {
                                this.setState({ code: value.target.value.toString(), errorCode: false });
                            }}
                            value={this.state.code}
                            type="text"
                            className="login-input"
                            name="inputEmail"
                            id="inputEmail"
                            placeholder="Enter Authentication Code"
                            style={this.state.errorCode ? { borderWidth: 1, borderColor: "red" } : {}}
                            required
                        />
                    </div>
                    <div className="form-group" style={{ margin: "0px", textAlign: "center" }}>
                        {this.state.customLoading ? (
                            <ProgressSpinner />
                        ) : (
                            <button type="button" onClick={() => this.handleTwoFactor()} className="signin-btn p-ripple">
                                <Ripple />   Submit
                            </button>
                        )}
                    </div>
                </Form>
            </div>
        </>)
    }

    renderForm = () => {
        if (this.state.selectedFormType == LoginFormType.MethodSelection) {
            return this.renderMethodSelectionForm()
        }
        else if (this.state.selectedFormType == LoginFormType.CodeVerification) {
            return this.renderTwofactorAuthenticationForm()
        }
        else {
            return this.renderLoginForm()
        }
    }

    renderPrivacyPolicy = () => {
        if (DetectEnvironment.config.REACT_APP_PRIVACY_POLICY != "") {
            return <>| <a className="privacy-policy" target="_blank" href={DetectEnvironment.config.REACT_APP_PRIVACY_POLICY}>Privacy Policy</a></>
        }

        return ""
    }

    render() {
        const { isLoading } = this.state;
        if (isLoading) {
            return <Spinner />;
        } else {
            return (
                <div className={DetectEnvironment.config.REACT_APP_BG_IMAGE_STYLE}>
                    <Toast ref={(r) => (this.toast = r as any)} />

                    <div className="login-box">
                        <MainLogo />

                        {this.renderForm()}

                        <div className="forget-password">
                            <NavLink to="/forgotPassword">Forgot Password?</NavLink>
                        </div>
                    </div>
                    <span className="copy-right">© {new Date().getFullYear()} {DetectEnvironment.config.REACT_APP_COPYRIGHT} {this.renderPrivacyPolicy()} </span>
                    {!utils.isThisMobileDevice() && <span className={`version ${utils.isInterChanges() && 'interchanges-verrsion'}`}>Version {process.env.REACT_APP_VERSION}</span>}
                </div>
            );
        }
    }
}

export default Login;
